export const NetworkContextName = "Ethereum";
export const ACTIVE_NETWORK = 0x1;
export const RPC_URL =
  "https://autumn-shy-research.quiknode.pro/6f104c6385b87fc415da37c0a0e389255d1e1178";
// export const base_url = "https://node.getrepotoken.io";
export const base_url = "https://node-telegramabdel.mobiloitte.io";
// export const base_url = "http://172.16.2.11:2027";
/////
